import type { SettingsTarget } from "@/components/settings/settings-navigation";
import { reconnectCompanionWithFeedback } from "@/desktop/companion-reconnect-action";
import { isTauri } from "@/lib/is-tauri";

/**
 * The rail's wrench. Desktop reconnects the local companion; the web has no
 * local subprocess to restart, so it opens the AI tools install guidance.
 */
export function runFixCompanionAction(
  openSettings: (target: SettingsTarget) => void,
) {
  if (!isTauri()) {
    openSettings({ page: "preferences-ai-tools" });
    return;
  }
  void reconnectCompanionWithFeedback();
}
